<template>
  <div class="user-management-container">
    <h1 class="user-management-title">用户管理</h1>
    <div class="user-list">
      <table class="user-table">
        <thead>
          <tr>
            <th>邮箱</th>
            <th>密码</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.email">
            <td>{{ user.email }}</td>
            <td>
              <span v-if="showPassword[user.email]">{{ user.password }}</span>
              <span v-else>******</span>
              <button
                class="toggle-password-button"
                @click="togglePassword(user.email)"
                v-if="!showPassword[user.email]"
              >
                显示
              </button>
              <button
                class="toggle-password-button"
                @click="togglePassword(user.email)"
                v-else
              >
                隐藏
              </button>
            </td>
            <td>
              <button @click="deleteUser(user.email)" class="delete-button">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <button @click="goToLogin" class="return-button">返回登录界面</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: JSON.parse(localStorage.getItem('users')) || [], // 从 localStorage 获取用户列表
      showPassword: {}, // 用于控制每个用户密码的显示状态
      passwordTimeout: null, // 用于控制密码显示的延时
    };
  },
  methods: {
    deleteUser(email) {
      const users = this.users.filter(user => user.email !== email);
      localStorage.setItem('users', JSON.stringify(users)); // 更新 localStorage 中的用户列表
      this.users = users; // 更新本地数据
      alert('用户已删除！');
    },
    goToLogin() {
      this.$emit('switch-to-login'); // 触发切换到登录页面的事件
    },
    togglePassword(email) {
      if (this.showPassword[email]) {
        // 如果当前密码是显示状态，切换为隐藏状态
        this.showPassword[email] = false;
        clearTimeout(this.passwordTimeout); // 清除之前的延时
      } else {
        // 如果当前密码是隐藏状态，切换为显示状态，并设置延时自动隐藏
        this.showPassword[email] = true;
        clearTimeout(this.passwordTimeout); // 清除之前的延时
        this.passwordTimeout = setTimeout(() => {
          this.showPassword[email] = false;
        }, 5000); // 5秒后自动隐藏密码
      }
    },
  },
};
</script>

<style scoped>
.user-management-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
}

.user-management-title {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #333;
}

.user-table {
  width: 100%;
  border-collapse: collapse;
}

.user-table th,
.user-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.user-table th {
  background-color: #f2f2f2;
}

.delete-button {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
}

.delete-button:hover {
  background: #a71d2a;
}

.return-button {
  margin-top: 1rem;
  padding: 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  width: 100%;
}

.return-button:hover {
  background: #0056b3;
}

.toggle-password-button {
  background: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 0.5rem;
}

.toggle-password-button:hover {
  background: #e0e0e0;
}
</style>
